import QuizItem from './QuizItem';
export default QuizItem;